const MIN_LENGTH_NAME = 2;
const MAX_LENGTH_NAME = 60;
const MAX_LENGTH_DESCRIPTION = 330;
const MEDIA_GRID_SM = 600;
const MEDIA_GRID_MD = 900;
const MEDIA_GRID_LG = 1160;

module.exports = {
    MIN_LENGTH_NAME,
    MAX_LENGTH_NAME,
    MAX_LENGTH_DESCRIPTION,
    MEDIA_GRID_SM,
    MEDIA_GRID_MD,
    MEDIA_GRID_LG,
};
